import Box from "@mui/material/Box";

const R = 42;

/** Circular progress ring for ~750ms long-press affordance (SVG, pointer-events none). */
export function LongPressProgressRing({
  progress,
  trackStroke,
  progressStroke,
}: {
  progress: number;
  trackStroke: string;
  progressStroke: string;
}) {
  const circumference = 2 * Math.PI * R;
  const dashOffset = circumference * (1 - progress);

  return (
    <Box
      component="svg"
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      sx={{ position: "absolute", inset: 0, pointerEvents: "none", transform: "rotate(-90deg)" }}
      aria-hidden
    >
      <circle cx="50" cy="50" r={R} fill="none" stroke={trackStroke} strokeWidth="5" />
      <circle
        cx="50"
        cy="50"
        r={R}
        fill="none"
        stroke={progressStroke}
        strokeWidth="5"
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={dashOffset}
        style={{ transition: progress === 0 ? "stroke-dashoffset 0.15s ease" : "none" }}
      />
    </Box>
  );
}
